import { render } from 'react-dom';
import { ReactElement } from 'react';

// does this work outside of renderWithTheme component???
require('../../styles/allstate.scss');

const renderWithTheme = (app: ReactElement): void => {
    render(app, document.getElementById('root'));
};

export default renderWithTheme;
